export const prettyNum = (value: number | string) =>
  String(value)
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");

export const roundToThousand = (value: number) =>
  (value | 0) - ((value | 0) % 1000);
